import React from 'react'

import { Row } from 'antd'
import { Gutter } from 'antd/lib/grid/row'

declare const RowAligns: ['top', 'middle', 'bottom', 'stretch']
declare const RowJustify: ['start', 'end', 'center', 'space-around', 'space-between']

export type Props = {
  gutter?: Gutter | [Gutter, Gutter]
  align?: (typeof RowAligns)[number]
  justify?: (typeof RowJustify)[number]
  prefixCls?: string
  wrap?: boolean
  children?: React.ReactNode
  className?: string
}

const Component: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Row gutter={props.gutter} {...props}>
      {props.children}
    </Row>
  )
}

export default Component
